import * as React from "react";
import { SettingsTemplate } from "../../../template/settings/default-template";
import {
  DocsService,
  DocsServiceProps,
} from "../../../../application/service/smart-apply/docs/docs-service";
import { connectPageService } from "../../../../application/domain/base/base-application-service";
import { formatDatetime } from "../../../../utils/date-utils";
import { useMount } from "../../../../utils/custom-hooks";
import {
  InformationBanner,
  PrimaryButton,
} from "@graffer-inc/console-design-kit";
import { StaticFeatureFlags } from "../../../../feature-flags";
import Analytics from "../../../../common/analytics";
import { useAuthContextV2 } from "../../../../auth-state";
import { Loader } from "../../../organisms/common/loading";

export const ServiceDocsPage: React.FC<DocsServiceProps> = ({
  isLoading,
  isDownloading,
  docs,
  fetchDocDetails,
  onDocDownloadRequested,
}) => {
  const authContext = useAuthContextV2();
  useMount(() => {
    fetchDocDetails();
  });

  return (
    <SettingsTemplate breadcrumbs={[{ to: "#", title: "マニュアル" }]}>
      <h1 className="title">
        <i className="fa fa-file-alt" /> Grafferサービスマニュアル
      </h1>
      {StaticFeatureFlags.IS_SANDBOX ? (
        <article className="message is-warning">
          <div className="message-body">
            サンドボックス環境では、サービスマニュアルをダウンロード頂くことはできません。
          </div>
        </article>
      ) : (
        <>
          <Loader isLoading={isLoading}>
            <div className="table-container">
              <table className="table is-fullwidth">
                <thead>
                  <tr>
                    <th>プロダクト名</th>
                    {/** 「最終更新日時」だとマニュアルの記載内容の更新日時と勘違いされそうなので、アップロード日時という言葉にしておく */}
                    <th>最終アップロード日時</th>
                    <th aria-label="ダウンロード"></th>
                  </tr>
                </thead>
                <tbody>
                  {docs
                    .filter((d) =>
                      authContext.auth.isProductAvailable(d.productCode),
                    )
                    .map((d) => (
                      <tr key={d.productCode} className="c-tr-has-tag">
                        <td>{d.productName}</td>
                        <td>{formatDatetime(d.updatedAt)}</td>
                        <td>
                          <PrimaryButton
                            text={"ダウンロード"}
                            onClick={async (e) => {
                              e.preventDefault();
                              Analytics.downloadGrafferServiceDocument();
                              await onDocDownloadRequested(d);
                            }}
                            disabled={isDownloading}
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </Loader>
          {!isLoading && docs.length === 0 && (
            <InformationBanner
              message="マニュアルがまだ登録されていません。"
              description="マニュアルが登録されると、ここに表示されます。"
            />
          )}
        </>
      )}
    </SettingsTemplate>
  );
};

export const ServiceDocsContainer = connectPageService(
  ServiceDocsPage,
  () => new DocsService(),
);
